import React from 'react'

const Videos = () => {
  return (
    <>
    <div className='videos'>
        <div className='videos1'>
            <h1>"<span>Thangaraj Matches</span> – Lighting the Way with Quality & Tradition"</h1>
    <iframe width="1012" height="625" src="https://www.youtube.com/embed/M1kr_30ZZH8" title="Thangaraj Match Factory Safety Matches Manufacturing Process" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>            </div>
    </div>
      <div className='videoss'>
        <div className='videos1'>
            <h1>"<span>Thangaraj Matches</span> – Lighting the Way with Quality & Tradition"</h1>
    <iframe width="253" height="156" src="https://www.youtube.com/embed/M1kr_30ZZH8" title="Thangaraj Match Factory Safety Matches Manufacturing Process" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>            </div>
    </div>
    </>
  )
}

export default Videos